import { cn } from '@crehana/compass.ui/v2';
import { useLiveSessionsTranslation } from "../../hooks/useLiveSessionsTranslation";
import { isToday } from "../../utils/isToday";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DateSessionHeader = function DateSessionHeader(_ref) {
  var date = _ref.date;
  var _useLiveSessionsTrans = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans.t,
    languageCode = _useLiveSessionsTrans.languageCode;
  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  var isTodaySessions = isToday(date);
  var isTomorrow = tomorrow.toDateString() === date.toDateString();
  return /*#__PURE__*/_jsxs("p", {
    className: cn('tw-font-label2 tw-text-1.4', isTodaySessions ? 'tw-text-primary-light-700 dark:tw-text-neutral-dark-300' : 'tw-text-neutral-light-600 dark:tw-text-neutral-dark-500'),
    children: [isTodaySessions && t('DATE_SESSIONS_HEADER_TODAY'), isTomorrow && t('DATE_SESSIONS_HEADER_TOMORROW', {
      interpolation: {
        date: date.toLocaleDateString(languageCode, {
          weekday: 'long'
        })
      }
    }), !isTodaySessions && !isTomorrow && date.toLocaleDateString(languageCode, {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })]
  });
};